export default __webpack_public_path__ + "static/media/phone3.94bfbbae.jpg";